import { render, staticRenderFns } from "./RedeemMembershipRoute.vue?vue&type=template&id=e4d052b8&"
import script from "./RedeemMembershipRoute.vue?vue&type=script&lang=ts&"
export * from "./RedeemMembershipRoute.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports